import useEmblaCarousel from "embla-carousel-react";
import React from "react";
import YouTube from "react-youtube";
import styled from "styled-components";
import { useDotButton } from "ui/blocks/ReviewSection/blocks/EmblaCarouselDotButton";
import { fonts, mediaSizes, themeColor } from "ui/theme";
import { extractYouTubeVideoId } from "utils/utils.ts";

const options = {align: "start"};

export const ClassOverview = ({title, gallery, introVideoUrl}) => {
    const [emblaRef, emblaApi] = useEmblaCarousel(options);

    const {selectedIndex, scrollSnaps, onDotButtonClick} = useDotButton(emblaApi);

    const modifiedGallery = [...gallery];
    if (introVideoUrl) {
        modifiedGallery.splice(0, 0, {type: "video", name: introVideoUrl});
    }

    return (
        <Embla>
            <EmblaTitleContainer>
                <EmblaTitle>{title}</EmblaTitle>

                {/*<EmblaButton>*/}
                {/*    <UploadIcon/>*/}
                {/*</EmblaButton>*/}
            </EmblaTitleContainer>

            <EmblaViewport ref={emblaRef}>
                <EmblaContainer>
                    {modifiedGallery?.map((item, index) => (
                        <EmblaSlide key={index}>
                            {item ? (
                                item.type === "video" ? (
                                    <YouTube
                                        className="youtube-wrapper desktop"
                                        iframeClassName="youtube-iframe"
                                        videoId={extractYouTubeVideoId(item.name)}
                                    />
                                ) : (
                                    <img src={item.name}/>
                                )
                            ) : (
                                <div></div>
                            )}
                        </EmblaSlide>
                    ))}
                </EmblaContainer>
            </EmblaViewport>

            <DotsRow>
                {scrollSnaps.map((_, index) => (
                    <Dot
                        key={index}
                        $active={index === selectedIndex}
                        onClick={() => onDotButtonClick(index)}
                        aria-label={`Slide ${index + 1}`}
                    />
                ))}
            </DotsRow>
        </Embla>
    );
};

const Embla = styled.section`
    display: grid;
    max-width: 100%;
    margin: auto;
    gap: 1.2rem;
    font-family: var(--font-secondary);
`;

const EmblaTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.2rem;
`;

const EmblaTitle = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: 600;

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.h4};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
    }
`;

const DotsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

const Dot = styled.button`
    width: ${({$active}) => $active ? "10px" : "8px"};
    height: ${({$active}) => $active ? "10px" : "8px"};
    border-radius: 50%;
    border: none;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;
    background: ${({$active}) => $active ? "#1d1d1f" : "rgba(29, 29, 31, 0.2)"};
    transition: background 0.2s ease, width 0.2s ease, height 0.2s ease;

    &:hover {
        background: ${({$active}) => $active ? "#1d1d1f" : "rgba(29, 29, 31, 0.4)"};
    }
`;

const EmblaViewport = styled.div`
    overflow: hidden;
`;

const EmblaContainer = styled.div`
    display: flex;
    touch-action: pan-y pinch-zoom;
    margin-left: calc(1rem * -1);
`;

const EmblaSlide = styled.div`
    flex: 0 0 100%;
    min-width: 0;
    padding-left: 1rem;

    & > div {
        width: 100%;
        background-color: ${themeColor("buttonBgNeutral")};
        aspect-ratio: 1.16;
        overflow: hidden;
        border-radius: 16px;

        & .youtube-wrapper,
        .youtube-iframe {
            width: 100%;
            height: 100%;
        }
    }

    & > img {
        width: 100%;
        background-color: ${themeColor("buttonBgNeutral")};
        aspect-ratio: 1.16;
        object-fit: cover;
        border-radius: 16px;
        display: block;
        max-height: 700px;
    }
`;





